<template>
  <v-data-table
    :items="items"
    v-bind="getOptions"
    class="elevation-1"
    dense
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <DynamicForm @submit="save" v-model="editedItem" :schema="schema" :options="formOptions"></DynamicForm>
            </v-card-text>

            <v-card-actions  v-if="false">
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">¿Estás seguro de que quieres eliminar este artículo?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <!--<template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>-->
  </v-data-table>
</template>

<script>
export default {
  name: 'DynamicTable',
  props: {
    title: String,
    value: {
      type: Array,
      default: () => ([])
    },
    options: Object,
    schema: {
      type: Object,
      required: true
    },
    formOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialog: false,
      dialogDelete: false,
      lazyValue: this.value,
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      }
    }
  },

  computed: {
    exclude () {
      return Object.entries(this.formOptions)
        .map(([key, value]) => (value.exclude && key)).filter((v) => !!v)
    },
    getOptions () {
      const options = this.options
      if (options?.headers?.length) {
        options.headers.push({ text: 'Acciones', value: 'actions', sortable: false })
      }
      return options
    },
    items: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', this.lazyValue)
      }
    },
    formTitle () {
      return this.editedIndex === -1 ? `Nuevo ${this.title}` : `Editar ${this.title}`
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    value (newVal, oldVal) {
      this.lazyValue = newVal
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      const details = this.schema.keys

      Object.entries(details).forEach(([name, def]) => {
        if (this.exclude.includes(name)) return
        let value = null
        if (def.type === 'array') {
          value = []
        }

        this.$set(this.defaultItem, name, value)
        this.$set(this.editedItem, name, value)
      })
    },

    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.items.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.items.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
